import { Convenio, FiltroConvenio } from '../../model/convenio/convenio';

/**
 * Puerto Abstracto: ConvenioRepository
 * 
 * Define el contrato para gestión de convenios.
 * 
 * Arquitectura Hexagonal:
 * - Este puerto está en el dominio
 * - HttpConvenioRepository (adaptador) lo implementa en infraestructura
 * 
 * @author GitHub Copilot - Migración GIROP
 */
export abstract class ConvenioRepository {

  /**
   * Busca convenios aplicando filtros opcionales.
   * 
   * @param filtro Criterios de búsqueda
   * @returns Lista de convenios que cumplen los criterios
   */
  abstract buscarConvenios(filtro: FiltroConvenio): Promise<Convenio[]>;
  
  /**
   * Obtiene un convenio por su ID.
   * 
   * @param nmconsecutivo ID del convenio
   * @returns Convenio encontrado
   */
  abstract obtenerPorId(nmconsecutivo: number): Promise<Convenio>;
  
  /**
   * Lista todos los convenios activos.
   * 
   * @returns Lista de convenios activos
   */
  abstract listarActivos(): Promise<Convenio[]>;
  
  /**
   * Lista convenios activos de una aseguradora.
   * 
   * @param nmconsecutivoCliente ID de la aseguradora
   * @returns Lista de convenios del cliente
   */
  abstract listarPorCliente(nmconsecutivoCliente: number): Promise<Convenio[]>;
}
